// extracted by mini-css-extract-plugin
export default {"container":"footer_container__2WLad","items":"footer_items__nogVL","item":"footer_item__3Q7V0"};